export default __webpack_public_path__ + "static/quality-b759852eb7be27cd897921bc87e69655.png";